var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8964_35216)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8964_35216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 1080
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V1080H1920V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8964_35216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V985.2H1920V0Z",
    fill: "url(#paint0_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1929.1 965.199H-2084V1849.8H1929.1V965.199Z",
    fill: "url(#paint1_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-136.898 969.301C-136.898 969.301 51.1016 970.701 106.202 956.601C143.902 947.001 181.002 946.601 208.802 940.301C310.502 917.001 346.202 926.801 384.002 933.401C421.302 939.901 443.502 905.501 481.302 908.601C514.102 911.201 562.702 938.101 612.202 921.701C661.702 905.301 699.402 902.201 762.002 908.301C824.602 914.401 933.002 921.701 933.002 921.701L1094.3 905.401L1242.1 873.401C1242.1 873.401 1348.1 848.201 1436.7 859.901C1525.3 871.601 1634.3 899.101 1634.3 899.101C1634.3 899.101 1718.6 908.701 1740.9 896.001C1761.2 884.501 1758.8 863.401 1828.5 859.801C1898.1 856.301 1920 846.301 1920 846.301V970.101L-136.898 969.301Z",
    fill: "url(#paint2_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1929.1 1364.3V1163L960.703 965.199L1929.1 1364.3Z",
    fill: "url(#paint3_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M960.703 965.199L1929.1 1127.9V1051.6L960.703 965.199Z",
    fill: "url(#paint4_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M960.703 965.199L1929.1 995.599V1029.7L960.703 965.199Z",
    fill: "url(#paint5_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M960.703 965.199L1929.1 983.099V965.199H960.703Z",
    fill: "url(#paint6_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M960.703 965.199L1929.1 1453V1814.7L960.703 965.199Z",
    fill: "url(#paint7_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M960.703 965.199L1661.8 1849.8H1135.4L960.703 965.199Z",
    fill: "url(#paint8_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M792.703 1849.8L960.703 965.199L258.203 1849.8H792.703Z",
    fill: "url(#paint9_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-2084 1177.8L960.7 965.199L-2084 1115.9V1177.8Z",
    fill: "url(#paint10_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-2084 1099.5L960.7 965.199L-2084 1056.9V1099.5Z",
    fill: "url(#paint11_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-2084 1039.4L960.7 965.199L-2084 1009.9V1039.4Z",
    fill: "url(#paint12_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-2084 982.699L960.7 965.199L-2084 997.399V982.699Z",
    fill: "url(#paint13_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-2084 965.199V974.099L960.7 965.199H-2084Z",
    fill: "url(#paint14_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-2084 1314.1L960.7 965.199L-2084 1209.6V1314.1Z",
    fill: "url(#paint15_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-2084 1611L960.7 965.199L-2084 1364.3V1611Z",
    fill: "url(#paint16_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-1410.5 1849.8L960.7 965.199L-2084 1709.4V1849.8H-1410.5Z",
    fill: "url(#paint17_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M-239.6 1849.8L960.7 965.199L-906 1849.8H-239.6Z",
    fill: "url(#paint18_linear_8964_35216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920 965.199V940.999C1920 940.999 1860.6 949.999 1831.5 965.099C1791.8 953.899 1721.7 940.299 1700.3 944.799C1678.9 949.299 1671.3 951.699 1660.6 948.199C1649.9 944.699 1549.3 965.199 1549.3 965.199L1384.6 960.499C1384.6 960.499 1372.4 938.899 1360.2 937.999C1348 937.099 1327 959.499 1327 959.499L1255 964.599C1255 964.599 1248.9 943.499 1238.2 944.799C1221.3 946.899 1211.8 958.499 1211.8 958.499L1088.5 964.699",
    fill: "#2C341B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8964_35216",
    x1: 975.131,
    y1: 1213.86,
    x2: 945.461,
    y2: -200.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#FFBB8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4542,
    stopColor: "#FFEBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDADE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8964_35216",
    x1: -116.698,
    y1: 1535.11,
    x2: 427.087,
    y2: -232.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E2F5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2913,
    stopColor: "#54315A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6703,
    stopColor: "#643657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#783C53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8964_35216",
    x1: 891.549,
    y1: 742.471,
    x2: 891.549,
    y2: 1240.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153D34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00385119,
    stopColor: "#163D35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6478,
    stopColor: "#7472A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9329,
    stopColor: "#9A88D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8964_35216",
    x1: 1491.49,
    y1: 707.245,
    x2: 1367.44,
    y2: 1925.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    stopColor: "#FF4CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8964_35216",
    x1: 1478.59,
    y1: 715.678,
    x2: 1363.29,
    y2: 1847.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    stopColor: "#FF4CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8964_35216",
    x1: 1496.73,
    y1: 488.518,
    x2: 1285.51,
    y2: 2562.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D03BCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8964_35216",
    x1: 1486.34,
    y1: 567.144,
    x2: 1306.81,
    y2: 2329.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1085,
    stopColor: "#C53EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8964_35216",
    x1: 1515.7,
    y1: 694.725,
    x2: 1385.7,
    y2: 1971.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    stopColor: "#FF4CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8964_35216",
    x1: 1386.11,
    y1: 672.443,
    x2: 1252.5,
    y2: 1984.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    stopColor: "#FF4CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8964_35216",
    x1: 692.322,
    y1: 593.549,
    x2: 555.435,
    y2: 1937.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    stopColor: "#FF4CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8964_35216",
    x1: -498.39,
    y1: 419.399,
    x2: -656.298,
    y2: 1969.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    stopColor: "#FF4CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8964_35216",
    x1: -500.082,
    y1: 406.534,
    x2: -663.036,
    y2: 2006.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    stopColor: "#DE55FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8964_35216",
    x1: -501.025,
    y1: 392.285,
    x2: -669.605,
    y2: 2047.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    stopColor: "#B557CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8964_35216",
    x1: -501.018,
    y1: 378.597,
    x2: -675.04,
    y2: 2087.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    stopColor: "#A357CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8964_35216",
    x1: -500.924,
    y1: 368.953,
    x2: -678.782,
    y2: 2115.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    stopColor: "#A357CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8964_35216",
    x1: -495.069,
    y1: 433.667,
    x2: -647.439,
    y2: 1929.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    stopColor: "#FF4CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8964_35216",
    x1: -488.824,
    y1: 449.672,
    x2: -635.084,
    y2: 1885.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    stopColor: "#FF4CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8964_35216",
    x1: -472.076,
    y1: 457.808,
    x2: -615.78,
    y2: 1868.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    stopColor: "#FF4CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_8964_35216",
    x1: 117.141,
    y1: 525.699,
    x2: -23.4308,
    y2: 1905.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1168,
    stopColor: "#FF4CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2F5B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8964_35216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage16);
export default __webpack_public_path__ + "static/media/image16.e2d98475d660d1c5fa7f064c1105a6b3.svg";
export { ForwardRef as ReactComponent };